<template>
	<div class="sidebar">
		<img src="static/img/icons/arrow-down-indicator-white.png" alt="" class="sidebar-arrow"/>		
		<h3 class="sidebar-header">Your Profile</h3>
		<hr/>
		<div class="country-detail">
			<img :src="'/static/img/flags/'+vModel.FlagCode+'.png'" alt=""/>
			<h4>
				{{vModel.FullName}} <br/><span class="country">{{vModel.Country}}</span></h4>
		</div>
		<hr/>
		<div class="personal-detail">
			<ul>
				<li>
					<p>Email :</p>
					<h4>{{vModel.EmailAddress}}</h4>
				</li>
				<li>
					<p>Date of Birth :</p>
					<h4>{{vModel.DateOfBirth}}</h4>
				</li>
				<li>
					<p>Phone Number :</p>
					<h4>{{vModel.PhoneNumber}}</h4>
				</li>
				<li>
					<p>ID Type:</p>
					<h4>{{vModel.IdType}}</h4>
				</li>
				<li>
					<p>ID Number:</p>
					<h4>{{vModel.IdNumber}}</h4>
				</li>
				<!-- <li>
					<p>ID Issue Country:</p>
					<h4>{{vModel.IdIssueCountry}}</h4>
				</li> -->
				<li v-if="vModel.RequireIdIssue">
					<p>ID Issued Date:</p>
					<h4>{{vModel.IdIssueDate}}</h4>
				</li>	
				<li v-if="vModel.RequireIdExpiry">
					<p>ID Expiry Date:</p>
					<h4>{{vModel.IdExpiryDate}}</h4>
				</li>			

				<li v-if="vModel.RequireVisaExpiry">
					<p>Visa Expiry Date:</p>
					<h4>{{vModel.VisaExpiry}}</h4>
				</li>
			</ul>
		</div>
		<br />
		<div v-if="currentRouteName=='/profile'">
			<button type="button" class="btn btn-sm btn-block btn-outline-danger" style="background-color:white"
			@click="deleteProfile">DELETE ACCOUNT</button>
		</div>
		<hr/>
	</div>       
</template>
<script>
import CommonService from "../services/common";
export default {
  name: "UserDetailSidebar",
  created() {
		this.vModel  = CommonService.getUserDetailInformation();
	},
	computed: {
		currentRouteName() {			
			return this.$route.fullPath;
		}
	},
	data() {
		return { vModel : {
			DateOfBirth : null,
			IdType: null,
			IdIssueCountry: null,
			IdIssueDate: null,
			IdExpiryDate: null,
			IdNumber: null,
			IsMalaysian: null,
			PhoneNumber : null,
			EmailAddress : null,
			RequireVisaExpiry: false,
			VisaExpiry : null,
			//PassportExpiry: null,
			Country:null,
			FlagCode : null,
			FullName : null
		}
		};
	},
	methods: {
		deleteProfile: function () {
				var self = this;
				if (self.isProcessing) return;
				kendo.confirm(
					"Are you sure you would like to delete your account?"			
				).then(function () {
					self.$http.post("customer/profile/delete").then(
						res => {
							CommonService.logOutAfterAccountDeletion();
							self.isProcessing = true;
							self.$toastr("success", "Your account has been deleted");
						},
						error => {
							self.isProcessing = false;
						}
					);
				}, function () {
					self.isProcessing = false;
				});

			}
	}
};
</script>


